import { RECEIVE_REGION } from "../actions/weatherRegionActions";
import {
  REQUEST_REGIONS,
  RECEIVE_REGIONS,
  FAILED_REGIONS,
  SELECT_REGION,
} from "./../actions/weatherRegionsActions";

export function weatherRegions(
  state = {
    isFetching: false,
    loadError: false,
    selectedRegion: null,
    items: [],
    perday: true,
  },
  action
) {
  switch (action.type) {
    case RECEIVE_REGION:
      return Object.assign({}, state, {
        isFetching: false,
      });
    case REQUEST_REGIONS:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_REGIONS:
      return Object.assign({}, state, {
        items: action.regions,
      });
    case SELECT_REGION:
      return Object.assign({}, state, {
        selectedRegion: action.regionId,
      });
    case FAILED_REGIONS:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
}
